<!-- 展示二维码弹窗 -->
<template>
	<el-dialog width="400px" :modal-append-to-body='false' :close-on-click-modal="false" :visible.sync="isShowDialog" :before-close='closeDialog'>
		<el-form>
			<div class="dialog-title">请扫码申请开票</div>
			<el-form-item>
				<div id="qrCode"></div>
			</el-form-item>
			<el-form-item class='qrcode-explain-box'>
				<div class='qrcode-explain'>{{qrCodeExplain}}</div>
			</el-form-item>
		</el-form>
	</el-dialog>
</template>

<script>
	import QRCode from 'qrcodejs2';

	export default {
		name: 'qrcode-dialog',
		props: {
			// 二维码内容
			qrCodeContent: {
				type: String,
				default: ""
			},
			// 二维码底部说明文字
			qrCodeExplain: {
				type: String,
				default: ""
			},
		},
		data() {
			return {
				isShowDialog: true, // 是否展示弹窗
			}
		},
		watch: {},
		mounted() {
			// 生成支付二维码
			this._createQRCode();
		},
		methods: {
			/**
			 * 关闭弹窗
			 */
			closeDialog() {
				// 调用父级确认方法
				this.$emit('close');
			},

			/**
			 * 创建二维码
			 */
			_createQRCode() {
				// 没有内容则直接返回
				if (!this.qrCodeContent) {
					return;
				}

				try {
					// 清空二维码容器内容
					document.getElementById("qrCode").innerHTML = "";
				} catch (e) {}

				let _this = this;
				// 生成支付二维码
				setTimeout(function() {
					// 生成二维码
					new QRCode("qrCode", {
						text: _this.qrCodeContent,
						width: 250,
						height: 250,
						colorDark: "#333333", //二维码颜色
						colorLight: "#ffffff", //二维码背景色
						correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
					});
				}, 100);
			},
		},
	}
</script>

<style scoped="scoped">
	.dialog-title {
		text-align: center;
		font-size: 22px;
		margin-bottom: 20px;
	}

	#qrCode {
		display: flex;
		justify-content: center;
	}

	.qrcode-explain-box {
		margin: 0;
		text-align: center;
		color: #666;
	}

	.qrcode-explain {
		font-size: 16px !important;
		margin-top: -10px;
	}
	
	.el-dialog__headerbtn {
	        font-size: 24px !important;
	}
</style>